import { createClient } from '@supabase/supabase-js';

// Use environment variables if available, otherwise fallback to the default project to prevent build crashes
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://ctmfzrddhpqtmslwoend.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN0bWZ6cmRkaHBxdG1zbHdvZW5kIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM3NjExNTEsImV4cCI6MjA4OTMzNzE1MX0.PQY1dIq4SmURKHGeDLHjUwvAm_82MdJgr2PPNKOjAWk';

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase credentials missing. Database features will not work.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
});